export default "__VITE_ASSET__b0795c86__"